
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abExperiments",
      function () {
        return require("private-next-pages/abExperiments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abExperiments"])
      });
    }
  